import { CategoryFormStep } from '@ebf/features/championships/domain/category-form-step.enum';

export enum Rounds {
  ONLINE_LATEX = 'onlineLatex',
  ONLINE_MODEL = 'onlineModel',
  LATEX = 'latex',
  MODEL = 'model',
}

export interface CategoryFormGeneral {
  description: string;
  rounds: Rounds[];
}

export interface CategoryFormRound {
  title: string;
  startDate: Date;
  time: string;
  winnersAllowed: number;
  durationHours: number;
  autoCompletable: boolean;
}

export interface CategoryFormCountry {
  countryId: string;
  winnersAllowed: number;
  rounds: Rounds[];
}

export interface CategoryForm {
  general: CategoryFormGeneral;
  [CategoryFormStep.ONLINE_LATEX]: CategoryFormRound;
  [CategoryFormStep.ONLINE_MODEL]: CategoryFormRound;
  [CategoryFormStep.LATEX]: CategoryFormRound;
  [CategoryFormStep.MODEL]: CategoryFormRound;
  countries: string[];
}
